import type { QuotesComponentProps } from './QuotesComponent';

export const QuotesComponent = {
    MountAsync: async (target: HTMLElement, props: QuotesComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { QuotesComponent } = await import('./QuotesComponent');
        return await mountReactComponentAsync(target, QuotesComponent, props);
    }
};
